import { Box, Paper } from '@mui/material';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
import React, { useMemo } from 'react';

const watermarkText = 'Psychiatric Assistance Dogs Foundation';

const watermarkSvg = encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="500" height="300">
  <text
    x="40"
    y="180"
    transform="rotate(-20 40 180)"
    font-family="Arial, sans-serif"
    font-size="24"
    font-weight="600"
    fill="#000000"
    fill-opacity="0.04"
  >
    ${watermarkText}
  </text>
</svg>
`);

const GuideLayout = ({
  children,
  watermark,
}) => {
  const theme = useTheme();
  // Global theme sets typography.body1/h4 to #444444 — override only inside the guide.
  // Explicit colors (sx/style/color prop) still win over these defaults.
  const guideTheme = useMemo(
    () =>
      createTheme(theme, {
        palette: {
          text: {
            primary: '#000000',
          },
        },
        typography: {
          h1: { color: '#000000' },
          h2: { color: '#000000' },
          h3: { color: '#000000' },
          h4: { color: '#000000' },
          h5: { color: '#000000' },
          h6: { color: '#000000' },
          subtitle1: { color: '#000000' },
          subtitle2: { color: '#000000' },
          body1: { color: '#000000' },
          body2: { color: '#000000' },
          caption: { color: '#000000' },
          overline: { color: '#000000' },
        },
      }),
    [theme],
  );

  const prevent = (e) => {
    e.preventDefault();
  };

  return (
    <ThemeProvider theme={guideTheme}>
      <Paper
        elevation={3}
        onCopy={prevent}
        onCut={prevent}
        onContextMenu={prevent}
        onDragStart={prevent}
        sx={{
          position: 'relative',
          color: 'text.primary',
          maxWidth: 900,
          mx: 'auto',
          p: { xs: 3, md: 6 },
          mb: 6,
          userSelect: 'none',
          WebkitUserSelect: 'none',
          MozUserSelect: 'none',
          WebkitTouchCallout: 'none',
          overflow: 'hidden',
          backgroundImage: `url("data:image/svg+xml,${watermarkSvg}")`,
          backgroundRepeat: 'repeat',
          backgroundPosition: 'center',
          backgroundSize: '500px 300px',
          '& img': {
            userSelect: 'none',
            pointerEvents: 'none',
          },
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 1 }}>{children}</Box>
      </Paper>
    </ThemeProvider>
  );
}

export default GuideLayout;
